import { useTranslation } from "react-i18next";
import { MapPinned } from "lucide-react";
import type { ResearchZone } from "./types";

export const ZoneCardsSection = ({ zones }: { zones?: ResearchZone[] }) => {
  const { t } = useTranslation();

  if (!zones || zones.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div className="px-5 py-3.5 border-b border-gray-100 flex items-center gap-2.5">
        <div className="w-8 h-8 rounded-lg bg-rose-50 flex items-center justify-center">
          <MapPinned size={16} className="text-rose-600" />
        </div>
        <h3 className="text-sm font-semibold text-gray-900">
          {t("smartSurveyor.researchReport.zoneStructure")}
        </h3>
        <span className="text-xs text-gray-400 ml-auto">
          {zones.length} {t("smartSurveyor.researchReport.zones")}
        </span>
      </div>
      <div className="p-4 space-y-2">
        {zones.map((z) => (
          <div
            key={z.zone_id}
            className="rounded-lg border border-gray-100 p-3.5 hover:border-gray-200 transition-colors"
          >
            <div className="flex items-center gap-2 mb-1">
              <span className="text-xs font-mono font-semibold text-gray-400 bg-gray-50 px-1.5 py-0.5 rounded">
                {z.zone_id}
              </span>
              <span className="text-sm font-medium text-gray-900">
                {z.name}
              </span>
              {z.scope && (
                <span className="text-xs bg-blue-50 text-blue-600 font-medium px-2 py-0.5 rounded-full">
                  {z.scope}
                </span>
              )}
            </div>
            {z.description && (
              <p className="text-xs text-gray-500 mb-2 leading-relaxed">
                {z.description}
              </p>
            )}
            <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-400">
              {z.page_count !== null && (
                <span>
                  {z.page_count} {t("smartSurveyor.researchReport.pages")}
                </span>
              )}
              {z.floor_levels && z.floor_levels.length > 0 && (
                <span>
                  {t("smartSurveyor.researchReport.floors")}:{" "}
                  {z.floor_levels.join(", ")}
                </span>
              )}
              {z.distribution_boards && z.distribution_boards.length > 0 && (
                <span>
                  {t("smartSurveyor.researchReport.boards")}:{" "}
                  {z.distribution_boards.join(", ")}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
